import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectEventTopPrizes } from "../../selectors/selectEventInfo";
import { selectIsRankingAvailable, selectSelectedLeague, selectTournamentDifficultyInfos, } from "../../selectors/selectTournamentInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { EventType } from "../balancing/types/BalancingCore";
import { ButtonSecondaryAccentLarge } from "../generic/common/ButtonSecondaryAccentLarge";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalTabSelect } from "../modals/actionModal";
import { ButtonGoto } from "./ButtonGoto";
import { EventPrizesRewards } from "./EventPrizesRewards";
import { IdCollectCategory } from "./IdCollectCategory";
import { IdTournamentCategory } from "./IdTournamentCategory";
var EventPrizesDOM = function (_a) {
    var isRankingAvailable = _a.isRankingAvailable, rewards = _a.rewards, openLeagueRankingTab = _a.openLeagueRankingTab, selectedLeague = _a.selectedLeague;
    var tournamentBadge = (React.createElement("div", { className: "tournament-info__top-prizes-badge" },
        React.createElement(Icon, { styleId: IdStyles.IconExtraLarge, icon: IdIcon.BadgeTournamentIcn })));
    var gotoLeagueRankingButton = (React.createElement(ButtonGoto, { onClick: function () { return openLeagueRankingTab(selectedLeague); }, destinationIcon: IdIcon.TournamentRankingIcn, buttonType: ButtonSecondaryAccentLarge }));
    return (React.createElement("div", { className: "tournament-info__top-prizes" },
        React.createElement("div", { className: IdStyles.TextBoldAccent + " event-prizes__title" },
            React.createElement(TextLoca, { id: IdLoca.topRewards })),
        React.createElement(EventPrizesRewards, { rewards: rewards }),
        isRankingAvailable ? gotoLeagueRankingButton : tournamentBadge));
};
var mapState = function (state) {
    var currentDifficulty = selectTournamentDifficultyInfos(state);
    var rewards = selectEventTopPrizes(state, currentDifficulty);
    var isRankingAvailable = selectIsRankingAvailable(state);
    return {
        isRankingAvailable: isRankingAvailable,
        rewards: rewards,
        selectedLeague: selectSelectedLeague(state) || EventType.PlayerLeague,
    };
};
var mapDispatch = function (dispatch) { return ({
    openLeagueRankingTab: function (eventId) {
        var tabId = eventId === EventType.CollectLeague
            ? IdCollectCategory.LeagueRanking
            : IdTournamentCategory.LeagueRanking;
        dispatch(actionModalTabSelect(tabId));
    },
}); };
export var EventPrizes = connect(mapState, mapDispatch)(EventPrizesDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/EventPrizes.tsx
// module id = 2773
// module chunks = 3